import type { ICuratedWishlistGroupResponse, IWishlistLinkResponse, IWishlistResponse, WishlistMode } from "@/types/wishlist.interface"

export class WishlistLink {
  public url?: string
  public label?: string
  public domain?: string
  public provider?: string
  public key?: string
  public providerAssetUrl?: string

  constructor(link: Partial<WishlistLink>) {
    this.url = link.url
    this.label = link.label
    this.domain = link.domain
    this.provider = link.provider
    this.key = link.key
    this.providerAssetUrl = link.providerAssetUrl
  }

  public static fromResponse(response?: IWishlistLinkResponse) {
    return new WishlistLink({
      url: response?.url,
      label: response?.label,
      domain: response?.domain,
      key: response?.key,
    })
  }
}

export class Wishlist {
  public wishlistMode?: WishlistMode
  public availableModes: WishlistMode[] = []
  public links: WishlistLink[] = []
  public curatedItems: WishlistLink[] = []

  constructor(wishlist: Partial<Wishlist>) {
    this.wishlistMode = wishlist.wishlistMode
    this.availableModes = wishlist.availableModes ?? []
    this.links = wishlist.links ?? []
    this.curatedItems = wishlist.curatedItems ?? []
  }

  public static fromResponse(response?: IWishlistResponse) {
    const curatedItems = response?.curated?.flatMap(group => mapCuratedGroupToLinks(group)) ?? []

    return new Wishlist({
      wishlistMode: response?.wishlistMode,
      availableModes: response?.availableModes ?? [],
      links: response?.links?.map(link => WishlistLink.fromResponse(link)) ?? [],
      curatedItems,
    })
  }
}

// API returns curated options grouped by provider; the UI needs a flat list with
// provider/key for saving and providerAssetUrl for logos on each item.
function mapCuratedGroupToLinks(group: ICuratedWishlistGroupResponse): WishlistLink[] {
  if (!group.items?.length)
    return []

  return group.items.map((item) => {
    const link = WishlistLink.fromResponse(item)
    link.provider = group.provider
    link.providerAssetUrl = group.providerAssetUrl
    return link
  })
}
